import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);

// Persiste valores definidos mesmo com refresh da tela
const vuexLocalStorage = new VuexPersist({
  key: "bughunt",
  storage: window.localStorage,
  reducer: (state) => ({
    currentUser: state.currentUser,
    amount_of_programs: state.amount_of_programs,
    amount_of_pentests: state.amount_of_pentests,
    submit_Report: state.submit_Report,
    programWithout: state.programWithout,
    cache_Report: state.cache_Report,
    routeTo: state.routeTo,
    can_access_ext_api: state.can_access_ext_api,
    safeTimeInactive: state.safeTimeInactive
  }),
  // filter: mutation => (true)
});

export default new Vuex.Store({
  state: {
    currentUser: {
      token: "",
      type: "",
      account_avatar: "",
      company_avatar: "",
      name: "",
      companyName: "",
      username: "",
      verified: "",
      paypal_account: "",
      amount_of_reports: "",
      score: "",
      email: "",
      role: "",
      company_createdAt: "",
      account_createdAt: "",
      company_settings: "",
      plan: null,
      termsUseConduct: false,
      currency: "USDT",
    },

    amount_of_programs: {
      private: 0,
      public: 0,
      vdp: 0,
    },

    amount_of_pentests:{
      whitebox: 0,
      blackbox: 0,
    },

    submit_Report: {
      program: [],
    },
    cache_Report: {},

    programWithout: "",

    apiUrl: process.env.VUE_APP_APIURL,

    timeInactive: "",
    safeTimeInactive: "",
    tokenSafe: "",

    routeTo: "",
    can_access_ext_api: "",
    two_factory_authentication: '',
  },
  mutations: {
    SET_CURRENT_USER(state, payload) {
      state.currentUser = Object.assign({}, state.currentUser, payload);
    },

    SET_AMOUNT_PROGRAMS(state, payload) {
      state.amount_of_programs = Object.assign(
        {},
        state.amount_of_programs,
        payload,
      );
    },

    SET_AMOUNT_PENTESTS(state, payload) {
      state.amount_of_pentests = Object.assign(
        {},
        state.amount_of_pentests,
        payload,
      );
    },

    SET_SUBMIT_REPORT(state, payload) {
      state.submit_Report.program = payload.program;
    },
    SET_CACHE_REPORT(state, payload) {
      state.cache_Report = Object.assign({}, state.cache_Report, payload);
    },

    SET_PROGRAM_WITHOUT(state, payload) {
      state.programWithout = payload;
    },

    REMOVE_CURRENT_USER(state) {
      state.currentUser.token = "";
      state.currentUser.type = "";
      state.currentUser.account_avatar = "";
      state.currentUser.company_avatar = "";
      state.currentUser.name = "";
      state.currentUser.companyName = "";
      state.currentUser.username = "";
      state.currentUser.verified = "";
      state.currentUser.paypal_account = "";
      state.currentUser.amount_of_reports = "";
      state.currentUser.score = "";
      state.currentUser.email = "";
      state.currentUser.role = "";
      state.currentUser.company_createdAt = "";
      state.currentUser.account_createdAt = "";
      state.currentUser.company_settings = "";
      state.amount_of_programs = {
        private: 0,
        public: 0,
        vdp: 0,
        target: 0
      };
      state.currentUser.plan = null;
    },

    REMOVE_CACHE_REPORT(state, payload) {
      state.cache_Report.program = payload.program;
      state.cache_Report.hacker = payload.hacker;
      state.cache_Report.title = "";
      state.cache_Report.selectedScope = "";
      state.cache_Report.selectedImpact = "";
      state.cache_Report.impact = "";
      state.cache_Report.selectedThreat = "";
      state.cache_Report.abstract = "";
      state.cache_Report.description = "";
    },

    SET_TIME_INACTIVE(state, payload) {
      state.timeInactive = payload;
    },
    SET_SAFE_TIME_INACTIVE(state, payload) {
      state.safeTimeInactive = payload;
    },
    SET_TOKEN_SAFE(state, payload) {
      state.tokenSafe = payload;
    },
    SET_ROUTE_TO(state, payload) {
      const regex = /^(?!\/\/)(?!.*(\.com|\.com\.br|%2e|%5e)).*$/;
      if(!regex.test(payload)) return;
      
      state.routeTo = payload;
    },
    SET_CAN_ACCESS_EXT_API(state, payload) {
      state.can_access_ext_api = payload;
    },
    SET_TWO_FACTORY_AUTHENTICATION(state, payload){
      state.two_factory_authentication = payload;
    },
    SET_TERMS_USE_CONDUCT(state, payload) {
      state.currentUser.termsUseConduct = payload;
    },
  },
  actions: {
    setUser: ({ commit }, payload) => commit("SET_CURRENT_USER", payload),
    resetUser: ({ commit }) => commit("REMOVE_CURRENT_USER"),
    setAmountPrograms: ({ commit }, payload) => commit("SET_AMOUNT_PROGRAMS", payload),
    setAmountPentests: ({ commit }, payload) => commit("SET_AMOUNT_PENTESTS", payload),
    setSubmitReport: ({ commit }, payload) => commit("SET_SUBMIT_REPORT", payload),
    setCacheReport: ({ commit }, payload) => commit("SET_CACHE_REPORT", payload),
    resetCacheReport: ({ commit }, payload) => commit("REMOVE_CACHE_REPORT", payload),
    setpProgramWithout: ({ commit }, payload) => commit("SET_PROGRAM_WITHOUT", payload),
    setTimeInactive: ({ commit }, payload) => commit("SET_TIME_INACTIVE", payload),
    setSafeTimeInactive: ({ commit }, payload) => commit("SET_SAFE_TIME_INACTIVE", payload),
    setTokenSafe: ({ commit }, payload) => commit("SET_TOKEN_SAFE", payload),
    setRouteTo: ({ commit }, payload) => commit("SET_ROUTE_TO", payload),
    setCanAccessExtApi: ({ commit }, payload) => commit("SET_CAN_ACCESS_EXT_API", payload),
    setTwoFactoryAuthenticaton: ({commit}, payload) => commit('SET_TWO_FACTORY_AUTHENTICATION', payload),
    setTermsUseConduct: ({commit}, payload) => commit('SET_TERMS_USE_CONDUCT', payload),
  },
  getters: {
    getToken: (state) => state.currentUser.token,
    getApiUrl: (state) => state.apiUrl,
    getUserType: (state) => state.currentUser.type,
    getCompany: (state) => state.currentUser.companyName,
    getLoggedIn: (state) => !!state.currentUser.token,
    getUser: (state) => state.currentUser,
    getAmount_programs: (state) => state.amount_of_programs,
    getAmount_pentests: (state) => state.amount_of_pentests,
    getSubmitReport: (state) => state.submit_Report,
    getCacheReport: (state) => state.cache_Report,
    getProgramWithout: (state) => state.programWithout,
    getTimeInactive: (state) => state.timeInactive,
    getRouteTo: (state) => state.routeTo,
    getCanAcessExtApi: (state) => state.can_access_ext_api,
    getUserRole: state => state.currentUser.role,
    getTwoFactorAuthRequired: state => state.currentUser.two_factor_auth_required,
    getTwoFactorAuthLogin: state => state.currentUser.two_factor_auth_login,
    getEmailCodeRequired: state => state.currentUser.email_code_required,
    getTermsUseConduct: state => state.currentUser.termsUseConduct,
  },

  plugins: [vuexLocalStorage.plugin],
});
